import { COPY } from '@utils/translation'
import { dateFormat } from '@utils/utilities'
import { useAmbassadorContext } from '@context/context'
import eventTracker from 'events/eventTracker/eventTracker'
import { EventType } from 'events/events'
import logAmbassadorEvent from 'events/eventTracker/logAmbassadorEvent'
import {
  AMBASSADOR_APPROVED_AT_KEY,
  AMBASSADOR_USER_TYPE_KEY,
  getGlobalProperties,
} from 'events/globalProperties'
import { StudentType } from '@utils/enum'

const hashMobile = (mobile?: string): string => {
  if (!mobile) return ''
  let hash = 5381
  for (let i = 0; i < mobile.length; i++) {
    hash = (hash * 33) ^ mobile.charCodeAt(i)
  }
  return (hash >>> 0).toString(16)
}

const useEvents = () => {
  const { myProfileValue, hamburgerClicked } = useAmbassadorContext()
  const user = JSON.parse(localStorage.getItem('user') || '{}')

  const codeCopyEvent = () => {
    const eventData = {
      program_name:
        myProfileValue && myProfileValue?.programType
          ? myProfileValue?.programType
          : '',
      tiers:
        myProfileValue && myProfileValue?.ambassadorLevel
          ? myProfileValue?.ambassadorLevel
          : '',
      coupon_generate:
        myProfileValue && myProfileValue?.couponCode ? 'Yes' : 'No',
      cta_click: COPY,
      date: dateFormat(new Date().toISOString()),
    }
    eventTracker.ambs_coupon_code_copy(eventData)
  }

  const logoutClickEvent = () => {
    const data = {
      program_name:
        myProfileValue && myProfileValue?.programType
          ? myProfileValue?.programType
          : '',
      tiers:
        myProfileValue && myProfileValue?.ambassadorLevel
          ? myProfileValue?.ambassadorLevel
          : '',
      coupon_generate:
        myProfileValue && myProfileValue?.couponCode ? 'Yes' : 'No',
    }
    eventTracker.ambs_logout_click(data)
  }

  const loginVisit = (loginSource: any, query: any) => {
    const eventData = {
      source: loginSource || '',
      utm_source:
        query && query.get('utm_source') ? query.get('utm_source') : '',
      utm_campaign:
        query && query.get('utm_campaign') ? query.get('utm_campaign') : '',
      utm_medium:
        query && query.get('utm_medium') ? query.get('utm_medium') : '',
    }
    eventTracker.ambs_login_visit(eventData)
  }

  const signinSuccessClick = (user_type: string) => {
    if (user_type) {
      localStorage.setItem(
        AMBASSADOR_USER_TYPE_KEY,
        user_type === 'registered' ? 'repeat' : 'new'
      )
    }
    const eventData = {
      program_name: myProfileValue?.programType || '',
      tiers: myProfileValue?.ambassadorLevel || '',
      coupon_generate: myProfileValue?.couponCode ? 'Yes' : 'No',
      user_type: user_type || '',
    }
    eventTracker.ambs_signin_success(eventData)
  }

  const otpPageClick = (click_cta: string) => {
    eventTracker.ambs_otp_page_click({ click_cta: click_cta })
  }

  const paymentUpdateSuccess = () => {
    const eventData = {
      program_name:
        myProfileValue && myProfileValue?.programType
          ? myProfileValue?.programType
          : '',
      date: dateFormat(new Date().toISOString()),
    }
    eventTracker.ambs_payment_update_success(eventData)
  }

  const personalDetailsVisit = () => {
    const eventData = {
      user_type:
        user && user?.firstName ? 'partial_registered' : 'not_registered',
    }
    eventTracker.ambs_personal_details_visit(eventData)
  }

  const programSelectVisit = () => {
    const eventData = {
      first_name: user?.firstName ? user?.firstName : '',
      last_name: user?.lastName ? user?.lastName : '',
      email: user?.email ? user?.email : '',
      city: user?.address?.city ? user?.address?.city : '',
      state: user?.address?.state ? user?.address?.state : '',
      user_type: user?.firstName ? 'partial_registered' : 'not_registered',
    }
    eventTracker.ambs_program_select_visit(eventData)
  }

  const dashboardVisit = () => {
    eventTracker.ambs_dashboard_visit(myProfileValue)
  }

  const landingPage = (query: any) => {
    const eventData = {
      utm_source:
        query && query.get('utm_source') ? query.get('utm_source') : '',
      utm_campaign:
        query && query.get('utm_campaign') ? query.get('utm_campaign') : '',
      utm_medium:
        query && query.get('utm_medium') ? query.get('utm_medium') : '',
    }
    eventTracker.ambs_landing_page(eventData)
  }

  const contactUsClick = () => {
    const data = {
      program_name:
        myProfileValue && myProfileValue?.programType
          ? myProfileValue?.programType
          : '',
      tiers:
        myProfileValue && myProfileValue?.ambassadorLevel
          ? myProfileValue?.ambassadorLevel
          : '',
      coupon_generate:
        myProfileValue && myProfileValue?.couponCode ? 'Yes' : 'No',
    }
    eventTracker.ambs_contact_us_click(data)
  }

  const generateCouponClick = () => {
    const eventData = {
      program_name:
        myProfileValue && myProfileValue?.programType
          ? myProfileValue?.programType
          : '',
      tiers:
        myProfileValue && myProfileValue?.ambassadorLevel
          ? myProfileValue?.ambassadorLevel
          : '',
      coupon_generate:
        myProfileValue && myProfileValue?.couponCode ? 'Yes' : 'No',
      generate_click: hamburgerClicked === 'coupon' ? 'hamburger' : 'dashboard',
      date: dateFormat(new Date().toISOString()),
    }
    eventTracker.generate_coupon_click(eventData)
  }

  const couponCodeVisit = () => {
    const eventData = {
      program_name:
        myProfileValue && myProfileValue?.programType
          ? myProfileValue?.programType
          : '',
      tiers:
        myProfileValue && myProfileValue?.ambassadorLevel
          ? myProfileValue?.ambassadorLevel
          : '',
      coupon_generate:
        myProfileValue && myProfileValue?.couponCode ? 'Yes' : 'No',
      source: hamburgerClicked === 'coupon' ? 'coupon_generator' : 'dashboard',
    }
    eventTracker.ambs_coupon_code_visit(eventData)
  }

  const earningLevelVsit = () => {
    const data = {
      program_name:
        myProfileValue && myProfileValue?.programType
          ? myProfileValue?.programType
          : '',
      tiers:
        myProfileValue && myProfileValue?.ambassadorLevel
          ? myProfileValue?.ambassadorLevel
          : '',
      coupon_generate:
        myProfileValue && myProfileValue?.couponCode ? 'Yes' : 'No',
    }
    eventTracker.ambs_earning_level_visit(data)
  }

  const paymentPageVist = () => {
    const data = {
      program_name:
        myProfileValue && myProfileValue?.programType
          ? myProfileValue?.programType
          : '',
      tiers:
        myProfileValue && myProfileValue?.ambassadorLevel
          ? myProfileValue?.ambassadorLevel
          : '',
      coupon_generate:
        myProfileValue && myProfileValue?.couponCode ? 'Yes' : 'No',
    }
    eventTracker.ambs_payment_page_visit(data)
  }

  const performanceReportVisit = () => {
    const data = {
      program_name:
        myProfileValue && myProfileValue?.programType
          ? myProfileValue?.programType
          : '',
      tiers:
        myProfileValue && myProfileValue?.ambassadorLevel
          ? myProfileValue?.ambassadorLevel
          : '',
      coupon_generate:
        myProfileValue && myProfileValue?.couponCode ? 'Yes' : 'No',
    }
    eventTracker.ambs_performance_report_visit(data)
  }

  const resourceCenterVisit = () => {
    const data = {
      program_name:
        myProfileValue && myProfileValue?.programType
          ? myProfileValue?.programType
          : '',
      tiers:
        myProfileValue && myProfileValue?.ambassadorLevel
          ? myProfileValue?.ambassadorLevel
          : '',
      coupon_generate:
        myProfileValue && myProfileValue?.couponCode ? 'Yes' : 'No',
    }
    eventTracker.ambs_resource_center_visit(data)
  }

  const signupSuccess = (
    data?: any,
    source?: string,
    Influencer?: any,
    courceName?: string,
    subSource?: string
  ) => {
    const eventData = {
      source: source || '',
      course_name: courceName ? courceName : '',
      campus_program_info: subSource ? subSource : '',

      influencer_youtube_link: Influencer
        ? Influencer?.channelUrl
          ? 'Yes'
          : 'No'
        : '',
      influencer_insta_link: Influencer
        ? Influencer?.instagramUrl
          ? 'Yes'
          : 'No'
        : '',
      influencer_facebook_link: Influencer
        ? Influencer?.profileUrl
          ? 'Yes'
          : 'No'
        : '',

      affiliate_type: data ? data?.affiliateType : '',
      affiliate_other: data && data?.role ? data?.role : '',
      signup_date: dateFormat(new Date().toISOString()),
    }
    eventTracker.ambs_signup_success(eventData)
    ambassadorProgrammeDetailsSubmitted(source || myProfileValue?.programType)
  }

  const paymentUpdateClick = () => {
    const eventData = {
      program_name:
        myProfileValue && myProfileValue?.programType
          ? myProfileValue?.programType
          : '',
      date: dateFormat(new Date().toISOString()),
    }
    eventTracker.ambs_payment_update_click(eventData)
  }

  const programDetailVisit = (programName: string) => {
    const eventData = {
      first_name: user?.firstName ? user?.firstName : '',
      last_name: user?.lastName ? user?.lastName : '',
      email: user?.email ? user?.email : '',
      city: user?.address?.city ? user?.address?.city : '',
      state: user?.address?.state ? user?.address?.state : '',
      user_type: user?.firstName ? 'partial_registered' : 'not_registered',
      program_select: programName ? programName : '',
    }
    eventTracker.ambs_program_detail_visit(eventData)
  }

  const otpPageVisit = () => {
    eventTracker.ambs_otp_page_visit()
  }

  const ambassadorLandingPageViewed = (query?: any) => {
    logAmbassadorEvent(EventType.AMBASSADOR_LANDING_PAGE_VIEWED, {
      referrer: typeof document !== 'undefined' ? document.referrer : '',
      utm_source: query?.get?.('utm_source') ?? '',
      utm_medium: query?.get?.('utm_medium') ?? '',
      utm_campaign: query?.get?.('utm_campaign') ?? '',
    })
  }

  const ambassadorLandingCtaClicked = (source: string, ctaText: string) => {
    logAmbassadorEvent(EventType.AMBASSADOR_LANDING_CTA_CLICKED, {
      source: source || '',
      cta_text: ctaText || '',
    })
  }

  const ambassadorOnboardingContinueClicked = (step: string, type?: string) => {
    logAmbassadorEvent(EventType.AMBASSADOR_ONBOARDING_CONTINUE_CLICKED, {
      step: type === 'mobile_number' ? hashMobile(step) : step,
    })
  }

  const ambassadorOnboardingOtpVerified = () => {
    logAmbassadorEvent(EventType.AMBASSADOR_ONBOARDING_OTP_VERIFIED, {})
  }

  const ambassadorProgrammeDiscoveryPageViewed = () => {
    logAmbassadorEvent(EventType.AMBASSADOR_PROGRAMME_DISCOVERY_PAGE_VIEWED, {})
  }

  const ambassadorProgrammeSelectionPersonaViewed = () => {
    logAmbassadorEvent(
      EventType.AMBASSADOR_PROGRAMME_SELECTION_PERSONA_VIEWED,
      {
        question_number: 1,
      }
    )
  }

  const ambassadorProgrammeSelectionPersonaSelected = (persona: string) => {
    logAmbassadorEvent(
      EventType.AMBASSADOR_PROGRAMME_SELECTION_PERSONA_SELECTED,
      {
        persona: persona || '',
      }
    )
  }

  const ambassadorProgrammeDetailsSubmitted = (programmeType?: string) => {
    logAmbassadorEvent(EventType.AMBASSADOR_PROGRAMME_DETAILS_SUBMITTED, {
      programme_type: programmeType || myProfileValue?.programType || '',
    })
  }

  const ambassadorDashboardPageViewed = () => {
    logAmbassadorEvent(EventType.AMBASSADOR_DASHBOARD_PAGE_VIEWED, {})
  }

  const ambassadorDashboardAddPaymentDetailsClicked = () => {
    logAmbassadorEvent(
      EventType.AMBASSADOR_DASHBOARD_ADD_PAYMENT_DETAILS_CLICKED,
      {}
    )
  }

  const ambassadorPaymentDetailsViewed = () => {
    logAmbassadorEvent(EventType.AMBASSADOR_PAYMENT_DETAILS_VIEWED, {})
  }

  const ambassadorPaymentSubmitClicked = () => {
    logAmbassadorEvent(EventType.AMBASSADOR_PAYMENT_SUBMIT_CLICKED, {})
  }

  const commissionStructurePageViewed = () => {
    logAmbassadorEvent(EventType.COMMISSION_STRUCTURE_PAGE_VIEWED, {})
  }

  const myAccountPageViewed = () => {
    logAmbassadorEvent(EventType.MY_ACCOUNT_PAGE_VIEWED, {})
  }

  const performanceReportPageViewed = () => {
    logAmbassadorEvent(EventType.PERFORMANCE_REPORT_PAGE_VIEWED, {})
  }

  const contactUsPageViewed = () => {
    logAmbassadorEvent(EventType.CONTACT_US_PAGE_VIEWED, {})
  }

  const ambassadorDashboardShareOfferClicked = () => {
    logAmbassadorEvent(EventType.AMBASSADOR_DASHBOARD_SHARE_OFFER_CLICKED, {})
  }

  const ambassadorSendOfferPageViewed = () => {
    logAmbassadorEvent(EventType.AMBASSADOR_SEND_OFFER_PAGE_VIEWED, {})
  }

  const ambassadorSendOfferEligibilityCheckClicked = (
    mobile?: string,
    studentType?: string
  ) => {
    logAmbassadorEvent(
      EventType.AMBASSADOR_SEND_OFFER_ELIGIBILITY_CHECK_CLICKED,
      {
        student_mobile_hash: hashMobile(mobile),
        student_type: studentType || '',
      }
    )
  }

  const ambassadorSendOfferRedirectToAssistedSalesClicked = () => {
    logAmbassadorEvent(
      EventType.AMBASSADOR_SEND_OFFER_REDIRECT_TO_ASSISTED_SALES_CLICKED,
      {
        source: 'send_offer_paid_student',
      }
    )
  }

  const ambassadorSendOfferOtpScreenViewed = (studentType?: string) => {
    logAmbassadorEvent(EventType.AMBASSADOR_SEND_OFFER_OTP_SCREEN_VIEWED, {
      student_type: studentType || StudentType.EXISTING_NON_PAID,
    })
  }

  const ambassadorSendOfferVerifyOtpClicked = (studentType?: string) => {
    logAmbassadorEvent(EventType.AMBASSADOR_SEND_OFFER_VERIFY_OTP_CLICKED, {
      student_type: studentType || '',
    })
  }

  const ambassadorSendOfferSuccessScreenViewed = (studentType?: string) => {
    logAmbassadorEvent(EventType.AMBASSADOR_SEND_OFFER_SUCCESS_SCREEN_VIEWED, {
      student_type: studentType || '',
    })
  }

  const ambassadorDashboardGenerateCouponClicked = (
    source: string,
    coupon_status?: string
  ) => {
    logAmbassadorEvent(EventType.AMBASSADOR_DASHBOARD_GENERATE_COUPON_CLICKED, {
      source: source || '',
      coupon_status: coupon_status || '',
    })
  }

  const ambassadorCouponGenerated = () => {
    let secondsFromApproval = 0
    try {
      const approvedAt = Number(
        localStorage.getItem(AMBASSADOR_APPROVED_AT_KEY) || '0'
      )
      if (approvedAt > 0) {
        secondsFromApproval = Math.max(
          0,
          Math.round((Date.now() - approvedAt) / 1000)
        )
      }
    } catch {
      secondsFromApproval = 0
    }

    logAmbassadorEvent(EventType.AMBASSADOR_COUPON_GENERATED, {
      programme_type: myProfileValue?.programType || '',
      coupon_type: 'standard',
      time_from_approval_to_coupon_seconds: secondsFromApproval,
    })
  }

  const sellNowEarnClicked = () => {
    logAmbassadorEvent(EventType.SELL_NOW_EARN_CLICKED, {
      programme_type: myProfileValue?.programType || '',
    })
  }

  const cohortSelectionPageViewed = ({
    source = '',
    cohortId,
  }: {
    source?: string
    cohortId?: string
  } = {}) => {
    const eventData: Record<string, unknown> = {
      ...getGlobalProperties(),
      user_segment: localStorage.getItem('batch_user_segment') || '',
      page_name: 'cohort_selection_page',
      source: source || '',
    }

    if (source === 'batch_listing_page' && cohortId) {
      eventData.cohort_id = cohortId
    }

    logAmbassadorEvent(EventType.COHORT_SELECTION_PAGE, eventData)
  }

  const cohortIsSelectedSuccessfully = ({
    source = '',
    cohortId,
    cohortName,
    previousCohortName,
    previousCohortId,
  }: {
    source?: string
    cohortId?: string
    cohortName?: string
    previousCohortName?: string
    previousCohortId?: string
  } = {}) => {
    const eventData: Record<string, unknown> = {
      ...getGlobalProperties(),
      user_segment: localStorage.getItem('batch_user_segment') || '',
      page_name: 'cohort_selection_page',
      cohort_name: cohortName || '',
      cohort_id: cohortId || '',
      source: source || '',
      previous_cohort_name: previousCohortName || '',
      previous_cohort_id: previousCohortId || '',
    }

    if (source === 'batch_listing_page' && cohortId) {
      eventData.cohort_id = cohortId
    }

    logAmbassadorEvent(EventType.COHORT_SELECTED, eventData)
  }

  const batchListingPageViewed = ({
    cohortId = '',
    source = '',
  }: {
    cohortId?: string
    source?: string
  } = {}) => {
    logAmbassadorEvent(EventType.BATCH_LISTING_PAGE, {
      ...getGlobalProperties(),
      cohort_id: cohortId || localStorage.getItem('COHORT_ID') || '',
      page_name: 'batch_listing_page',
      platform: getGlobalProperties().platform,
      source: source || '',
      user_id: localStorage.getItem('BATCH_BUY_USER_ID') || '',
      user_segment: localStorage.getItem('batch_user_segment') || '',
      programme_type: myProfileValue?.programType || '',
    })
  }

  const getSalesBatchType = (
    batchType?: string,
    batchDetails?: Record<string, any>
  ): string => {
    if (batchType === 'power_batch' || batchDetails?.masterBatchId) {
      return 'power_batch'
    }
    if (batchDetails?.isPathshala || batchDetails?.config?.isVidyapeeth) {
      return 'offline'
    }
    return 'online'
  }

  const salesBuyNowClicked = ({
    batchId = '',
    batchType = '',
    batchPrice = 0,
  }: {
    batchId?: string
    batchType?: string
    batchPrice?: number
  } = {}) => {
    const batchDetails = JSON.parse(
      localStorage.getItem('BATCH_DETAILS') || '{}'
    )

    logAmbassadorEvent(EventType.SALES_BUY_NOW_CLICKED, {
      ...getGlobalProperties(),
      batch_id: batchId || batchDetails?._id || '',
      batch_type: getSalesBatchType(batchType, batchDetails),
      batch_price: Number(batchPrice || batchDetails?.card?.fees?.total) || 0,
    })
  }

  const salesProceedClicked = ({
    batchId = '',
    batchType = '',
    batchPrice = 0,
  }: {
    batchId?: string
    batchType?: string
    batchPrice?: number
  } = {}) => {
    const batchDetails = JSON.parse(
      localStorage.getItem('BATCH_DETAILS') || '{}'
    )

    logAmbassadorEvent(EventType.SALES_PROCEED_CLICKED, {
      ...getGlobalProperties(),
      batch_id: batchId || batchDetails?._id || '',
      batch_type: getSalesBatchType(batchType, batchDetails),
      batch_price: Number(batchPrice || batchDetails?.card?.fees?.total) || 0,
    })
  }

  const salesStudentOtpVerifiedClicked = ({
    batchId = '',
    batchType = '',
    batchPrice = 0,
  }: {
    batchId?: string
    batchType?: string
    batchPrice?: number
  } = {}) => {
    const batchDetails = JSON.parse(
      localStorage.getItem('BATCH_DETAILS') || '{}'
    )

    logAmbassadorEvent(EventType.SALES_STUDENT_OTP_VERIFIED, {
      ...getGlobalProperties(),
      batch_id: batchId || batchDetails?._id || '',
      batch_type: getSalesBatchType(batchType, batchDetails),
      batch_price: Number(batchPrice || batchDetails?.card?.fees?.total) || 0,
    })
  }

  const transactionStatus = (eventData: any) => {
    logAmbassadorEvent(EventType.TRANSACTION_STATUS, {
      ...getGlobalProperties(),
      ...eventData,
    })
  }

  return {
    codeCopyEvent,
    logoutClickEvent,
    resourceCenterVisit,
    performanceReportVisit,
    paymentPageVist,
    earningLevelVsit,
    couponCodeVisit,
    generateCouponClick,
    contactUsClick,
    landingPage,
    dashboardVisit,
    programSelectVisit,
    personalDetailsVisit,
    paymentUpdateSuccess,
    otpPageClick,
    signinSuccessClick,
    loginVisit,
    signupSuccess,
    paymentUpdateClick,
    programDetailVisit,
    otpPageVisit,
    ambassadorLandingPageViewed,
    ambassadorLandingCtaClicked,
    ambassadorOnboardingContinueClicked,
    ambassadorOnboardingOtpVerified,
    ambassadorProgrammeDiscoveryPageViewed,
    ambassadorProgrammeSelectionPersonaViewed,
    ambassadorProgrammeSelectionPersonaSelected,
    ambassadorProgrammeDetailsSubmitted,
    ambassadorDashboardPageViewed,
    ambassadorDashboardAddPaymentDetailsClicked,
    ambassadorPaymentDetailsViewed,
    ambassadorPaymentSubmitClicked,
    commissionStructurePageViewed,
    myAccountPageViewed,
    performanceReportPageViewed,
    contactUsPageViewed,
    ambassadorDashboardShareOfferClicked,
    ambassadorSendOfferPageViewed,
    ambassadorSendOfferEligibilityCheckClicked,
    ambassadorSendOfferRedirectToAssistedSalesClicked,
    ambassadorSendOfferOtpScreenViewed,
    ambassadorSendOfferVerifyOtpClicked,
    ambassadorSendOfferSuccessScreenViewed,
    ambassadorDashboardGenerateCouponClicked,
    ambassadorCouponGenerated,
    sellNowEarnClicked,
    cohortSelectionPageViewed,
    cohortIsSelectedSuccessfully,
    batchListingPageViewed,
    salesBuyNowClicked,
    salesProceedClicked,
    salesStudentOtpVerifiedClicked,
    transactionStatus,
  }
}

export default useEvents
